import { createSidebarRequest } from '@/features/sidebar';
import type { AddonPurchaseData, AddonPurchaseResult } from './addon-purchase-panel';

export const ADDON_PURCHASE_SIDEBAR_ID = 'flex-addon-purchase';

export const addonPurchaseRequest = createSidebarRequest<AddonPurchaseData, AddonPurchaseResult>(
  ADDON_PURCHASE_SIDEBAR_ID,
);
